import React from 'react';

import { Image } from '../../../foundations/Image/Image';
import { buildImageSizes } from '../../../foundations/Image/utils/buildImageSizes';
import type { ImageSrcSet } from '../../../foundations/Image/utils/buildImageSrcSet';
import { buildImageSrcSet } from '../../../foundations/Image/utils/buildImageSrcSet';
import type { FloatingBannerImageProps } from '../types';
import * as styles from './FloatingBannerImage.styles';

const aspectRatioPropStylesMap = {
  '1 / 1': styles.ar11,
  '4 / 3': styles.ar43,
  '16 / 9': styles.ar169,
  auto: styles.arAuto,
};

export const FloatingBannerImage = ({
  imageAlt,
  imageAspectRatio = '16 / 9',
  imageHeight,
  imageWidth,
  images,
  lazyImages,
  offset,
}: FloatingBannerImageProps) => {
  const imagesWithUnit: ImageSrcSet[] = images.map(({ src, width }) => ({ src, width, unit: 'w' }));
  const aspectRatioStyle =
    aspectRatioPropStylesMap[imageAspectRatio] || aspectRatioPropStylesMap.auto;

  return (
    <div css={[styles.imageContainer, offset && styles[offset]]}>
      <Image
        alt={imageAlt}
        css={[styles.image, aspectRatioStyle]}
        height={imageHeight}
        loading={lazyImages ? 'lazy' : 'eager'}
        sizes={buildImageSizes({
          XXS: '100vw',
          M: '50vw',
          XL: '566px',
        })}
        src={images[0]?.src}
        srcSet={buildImageSrcSet(imagesWithUnit)}
        width={imageWidth}
      />
    </div>
  );
};
